<div>
    <div class="card-holder --newBrand">
        <p class="card-holder-label" data-test="labelAdmissionDate">Data de admissão:</p>
        <p class="additional-info-value" data-test="valueAdmissionDate">{{ infos?.admission?.date | date: 'dd/MM/yyyy' }}</p>
        <up-ui-copy-button [newBrand]=true [id]="'btnCopyAdmissionDate'" [label]="infos?.admission?.date | date: 'dd/MM/yyyy'"></up-ui-copy-button>

    </div>
    <div class="card-holder --newBrand">
        <p class="card-holder-label" data-test="labelEmployeeCode">Número de matrícula:</p>
        <p class="additional-info-value" data-test="valueEmployeeCode">{{ infos?.employeeCode || '--' }}</p>
        <up-ui-copy-button [newBrand]=true [id]="'btnCopyAdmissionDate'" [label]="infos?.employeeCode"></up-ui-copy-button>
    </div>
    <div class="card-holder --newBrand">
      <p class="card-holder-label" data-test="labelleaderName">Líder:</p>
      <p class="additional-info-value" data-test="valueleaderName">{{ infos?.admission?.leaderName || '--' }}</p>
      <up-ui-copy-button [newBrand]=true [id]="'btnCopyAdmissionDate'" [label]="infos?.admission?.leaderName"></up-ui-copy-button>
  </div>
  <div class="card-holder --newBrand">
    <p class="card-holder-label" data-test="labelleaderEmail">E-mail do líder:</p>
    <p class="additional-info-value" data-test="valueleaderEmail">{{ infos?.admission?.leaderEmail || '--' }}</p>
    <up-ui-copy-button [newBrand]=true [id]="'btnCopyAdmissionDate'" [label]="infos?.admission?.leaderEmail"></up-ui-copy-button>
  </div>
</div>
